import { useContext } from 'react';

import { ToastContext } from '../context/ToastContextProvider';

export const useToasts = () => useContext(ToastContext);
